import React, { useState } from 'react';
import { IconButton, Popover } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { Stack } from '@mui/system';

import { Button } from '../components/core/Button/Button';

interface Props {
  actions: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    shouldRender?: boolean;
    shouldClosePopover?: boolean;
  }[];
  ariaLabel: string;
}

export const ActionsPopover = ({ actions, ariaLabel }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'actions-popover' : undefined;

  return (
    <>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        aria-label={ariaLabel}
        sx={{ m: -1.5, color: 'link.main' }}
      >
        <MoreHoriz />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack sx={{ padding: '17px 28px 20px 18px', gap: '12px' }}>
          {actions
            .filter((action) => action.shouldRender ?? true)
            .map(({ label, onClick, disabled, shouldClosePopover = true }) => (
              <Button
                key={label}
                text={label}
                variant="text"
                onClick={() => {
                  onClick();
                  if (shouldClosePopover) {
                    handleClose();
                  }
                }}
                disabled={disabled}
                sx={{
                  px: 1,
                  py: 0.5,
                  textDecoration: 'underline',
                  justifyContent: 'flex-start',
                  width: 'fit-content',
                  '&:hover': {
                    textDecoration: 'none',
                  },
                  '& p': {
                    color: 'link.main',
                  },
                }}
              />
            ))}
        </Stack>
      </Popover>
    </>
  );
};
